import React from 'react';
import HeaderMain from '../HeaderMain/HeaderMain';
import './Header.css'

const Header = () => {
    return (
        <div className="Header-container">
            {/* <Navbar></Navbar> */}
            <HeaderMain></HeaderMain>
        </div>
    );
};

export default Header;